export const SET_USER = 'SET_USER';
export const LOGOUT = 'LOGOUT';

// Action to set user info after Okta login
export const setUser = (userData: any) => ({
    type: SET_USER,
    payload: userData
  });
  
// Action to logout the user
export const logout = () => ({
    type: LOGOUT,
  });